/* eslint-disable camelcase */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import classnames from 'classnames';
import t, { Trans } from 'translations';
import { subscribe as subscribeOverlay, unsubscribe as unsubscribeOverlay } from 'util/misc/overlay-tracker';

import Slider from 'components/slider';
import Card from 'components/cms-placeholder/card-stack/card';
import CardContent from 'components/cms-placeholder/card-stack/card-content';
import sliderConfig from './slider-config';
import Button from 'components/button';
import Icon from 'components/icon';
import ZipForm from 'components/zip-form';
import PrelauchForm from 'components/prelaunch-form';

import { CARD } from 'constants/placeholder-events';
import Aria51 from 'components/aria-51';

// Card type constants
export const TYPE_CARD = 'card';
export const TYPE_START_CART = 'start-cart';
export const TYPE_NEWSLETTER = 'subscribe';
export const TYPE_APP_STORE = 'app_store_buttons_on_last_card';

export default class CardSlider extends PureComponent {
    static defaultProps = {
        features: [],
    };


    static propTypes = {
        cards: PropTypes.array.isRequired,
        style: PropTypes.string.isRequired,
        isOpen: PropTypes.bool,
        onEvent: PropTypes.func,
        app_store_link: PropTypes.string,
        google_play_link: PropTypes.string,
        features: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            // HACKS OVER HACKS OVER HACKS HERE sorry :(
            hasFormCard: props.cards.some(c => [TYPE_START_CART, TYPE_NEWSLETTER].includes(c.type)),
            activeIndex: 0,
            sliderIsOpen: false,
        };
    }

    componentWillMount() {
        subscribeOverlay(this, this.triggerEvent);
    }

    componentWillReceiveProps({ isOpen }) {
        if (this.refs.slider.swiper) {
            this.refs.slider.swiper.keyboard[isOpen ? 'enable' : 'disable']();
        }
    }

    componentWillUnmount() {
        unsubscribeOverlay(this);
    }

    get facet() {
        return `card-${ this.props.style }-slider`;
    }

    handleSlideChangeEnd = ({ activeIndex }) => {
        this.setState({ activeIndex });
    };


    triggerEvent = () => {
        const { onEvent } = this.props;

        if (onEvent) {
            onEvent(CARD, { sliderIsOpen: null });
        }
    };

    renderCard(card, key) {
        const { app_store_link, google_play_link, features, cards, isOpen } = this.props;
        const { activeIndex } = this.state;

        let lastCard = false;
        if ((cards.length - 1) === key) {
            lastCard = true;
        }

        switch (card.type) {
            case TYPE_START_CART:
                return (
                    <div className="card-slider--zip-form" key={key}>
                        <div className="card-slider--zip-form-inner">
                            <h1 className="card-slider--zip-title">
                                <Trans path='onboarding.zip.title'/>
                            </h1>
                            <p className="card-slider--zip-text">
                                <Trans path='onboarding.zip.text'/>
                            </p>
                            <div className="card-slider--close">
                                <Button
                                    aria-label={t('accessibility.label.close_cards')}
                                    tag={'button'}
                                    facet={['bubble', 'large', 'tertiary']}
                                    onClick={this.triggerEvent}
                                >
                                    <Icon symbol={'cancel'} size={'medium'}/>
                                </Button>
                            </div>
                            <div className="card-slider--zip-form-card">
                                <ZipForm autoFocus={false} />
                            </div>
                        </div>
                    </div>
                );
            // TODO: remove this case as soon as we go live
            case TYPE_NEWSLETTER:
                return (
                    <div className="card-slider--zip-form" key={key}>
                        <div className="card-slider--zip-form-inner">
                            <h1 className="card-slider--zip-title">
                                <Trans path='prelaunch.card.form.title'/>
                            </h1>
                            <p className="card-slider--zip-text">
                                <Trans path='prelaunch.card.form.description'/>
                            </p>
                            <div className="card-slider--close">
                                <Button
                                    aria-label={t('accessibility.label.close_cards')}
                                    tag={'button'}
                                    facet={['bubble', 'large', 'tertiary']}
                                    onClick={this.triggerEvent}
                                >
                                    <Icon symbol={'cancel'} size={'medium'}/>
                                </Button>
                            </div>
                            <div className="card-slider--zip-form-card">
                                <PrelauchForm autoFocus={false}/>
                            </div>
                        </div>
                    </div>
                );
            case TYPE_CARD:
            // case TYPE_APP_STORE:
            default:
                return (
                    <Card key={key} facet={'slider'}>
                        <div className="card-slider--close">
                            <Button aria-label={t('accessibility.label.close_cards')} tag={'button'}
                                facet={['bubble', 'large', 'tertiary']} onClick={this.triggerEvent}>
                                <Icon symbol={'cancel'} size={'medium'}/>
                            </Button>
                        </div>
                        <CardContent
                            {...card}
                            app_store_buttons_on_last_card={(features.includes(TYPE_APP_STORE) && lastCard)}
                            app_store_link={app_store_link}
                            google_play_link={google_play_link}
                            visible={key === activeIndex && isOpen}
                        />
                    </Card>
                );
        }
    }

    render() {
        const { cards, style, isOpen } = this.props;
        const { activeIndex, hasFormCard } = this.state;

        return (
            <Aria51 isActive={isOpen}
                aria-hidden={!isOpen}
                className={classnames(`card-slider card-slider__${ style }`, {
                    'card-slider__is-visible': isOpen,
                    'card-slider__form': hasFormCard,
                })}>
                <Slider ref="slider"
                    facet={this.facet}
                    config={sliderConfig}
                    on={{ slideChangeTransitionEnd: this.handleSlideChangeEnd }}>
                    {looppa(cards)((card, index) => this.renderCard(card, index, activeIndex))}
                </Slider>
            </Aria51>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/card-slider/index.js